// Session storage keys for catering data
const CATERING_STORAGE_KEYS = {
    ADDRESS: 'catering_address',
    SCHEDULE: 'catering_schedule',
    IS_VALID: 'catering_is_valid',
    STORE: 'catering_store'
};

// Save catering data to session storage
export const saveCateringData = (address, schedule, store) => {
    try {
        if (address) {
            sessionStorage.setItem(CATERING_STORAGE_KEYS.ADDRESS, JSON.stringify(address));
        }
        if (schedule) {
            sessionStorage.setItem(CATERING_STORAGE_KEYS.SCHEDULE, JSON.stringify(schedule));
            sessionStorage.setItem(CATERING_STORAGE_KEYS.IS_VALID, 'true');
        }
        if (store) {
            sessionStorage.setItem(CATERING_STORAGE_KEYS.STORE, JSON.stringify(store));
        }
    } catch (error) {
        console.error('Error saving catering data to session storage:', error);
    }
};

// Get catering data from session storage
export const getCateringData = () => {
    try {
        const addressData = sessionStorage.getItem(CATERING_STORAGE_KEYS.ADDRESS);
        const scheduleData = sessionStorage.getItem(CATERING_STORAGE_KEYS.SCHEDULE);
        const storeData = sessionStorage.getItem(CATERING_STORAGE_KEYS.STORE);
        const isValid = sessionStorage.getItem(CATERING_STORAGE_KEYS.IS_VALID) === 'true';

        return {
            address: addressData ? JSON.parse(addressData) : null,
            schedule: scheduleData ? JSON.parse(scheduleData) : null,
            store: storeData ? JSON.parse(storeData) : null,
            isValid
        };
    } catch (error) {
        console.error('Error getting catering data from session storage:', error);
        return {
            address: null,
            schedule: null,
            store: null,
            isValid: false
        };
    }
};

// Clear catering data from session storage
export const clearCateringData = () => {
    try {
        sessionStorage.removeItem(CATERING_STORAGE_KEYS.ADDRESS);
        sessionStorage.removeItem(CATERING_STORAGE_KEYS.SCHEDULE);
        sessionStorage.removeItem(CATERING_STORAGE_KEYS.IS_VALID);
    } catch (error) {
        console.error('Error clearing catering data from session storage:', error);
    }
};

// Check if catering data exists in session storage
export const hasCateringData = () => {
    const data = getCateringData();
    return data.address && data.schedule && data.isValid;
};

// Restore catering data to Redux state
export const restoreCateringData = (dispatch, setAddress, setCateringSchedule) => {
    const data = getCateringData();
    
    if (data.address && setAddress) {
        setAddress(data.address);
    }
    
    if (data.schedule && setCateringSchedule) {
        setCateringSchedule({ ...data.schedule, isValid: true });
    }
    
    return data;
};
